import { useRole } from "@/contexts/RoleContext";
import { useOrgCommandCenterSettings } from "@/hooks/useAdminDashboardData";
import {
  membershipCanViewOrgFinancials,
  pickCurrentMembership,
} from "@/lib/orgFinancialAccess";

export function useCanViewOrgFinancials(): boolean {
  const { currentRole, currentOrgId, memberships } = useRole();
  const needsOrgFlag =
    Boolean(currentOrgId) &&
    (currentRole === "owner" || currentRole === "coordinator");
  const { data: orgSettings } = useOrgCommandCenterSettings(
    currentOrgId,
    needsOrgFlag
  );
  const membership = pickCurrentMembership(
    memberships,
    currentOrgId,
    currentRole
  );

  return membershipCanViewOrgFinancials({
    role: currentRole,
    canViewFinancials: membership?.can_view_financials,
    canViewBilling: membership?.can_view_billing,
    permissions: membership?.permissions,
    globalCoordinatorViewFinancials:
      orgSettings?.globalCoordinatorViewFinancials,
  });
}
